import {
    FETCH_AGGREGATE_DOMAINS_REQUEST,
    FETCH_AGGREGATE_DOMAINS_SUCCESS,
    FETCH_AGGREGATE_DOMAINS_FAILURE,
} from '../actions/types/aggregate-domains-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_DOMAINS_REQUEST:
            newState = true;
            break;
        case FETCH_AGGREGATE_DOMAINS_SUCCESS:
        case FETCH_AGGREGATE_DOMAINS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_DOMAINS_SUCCESS:
            newState = action.byId;
            break;
        case FETCH_AGGREGATE_DOMAINS_REQUEST:
        case FETCH_AGGREGATE_DOMAINS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function allIds( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_DOMAINS_SUCCESS:
            newState = action.allIds;
            break;
        case FETCH_AGGREGATE_DOMAINS_REQUEST:
        case FETCH_AGGREGATE_DOMAINS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

function params( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_DOMAINS_REQUEST:
            newState = action.params;
            break;
        case FETCH_AGGREGATE_DOMAINS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    allIds,
    byId,
    isLoading,
    params
} );
